<template>
  <div class="page">
    <HorizontalScroll>
      <div class="list1">
          <div class="item1" :class="current_cid1?'':'hover1'" @click="getAll()">全部</div>
          <div class="item1" :class="current_cid1==item.id?'hover1':''" v-for="(item,index) in list1" :key="index" @click="changeTab1(item)">{{item.title}} <span class="iconfont icon-zhankai-01" :class="current_cid1==item.id?'icon_hover':''"></span></div>
      </div>
    </HorizontalScroll>
    <div class="att_list" v-if="current_cid2&&!show1">
      <div class="att_item" :class="tab==1||current_label1?'hover3':''" @click="changeLabel(1)">RCF
        <span class="iconfont icon-zhankai-01" :class="tab==1||current_label1?'icon_hover':''"></span>
      </div>
      <div class="att_item" :class="tab==2||current_label2?'hover3':''" @click="changeLabel(2)">容量
        <span class="iconfont icon-zhankai-01" :class="tab==2||current_label2?'icon_hover':''"></span>
      </div>
      <div class="att_item" :class="tab==3||current_label3?'hover3':''" @click="changeLabel(3)">材质
        <span class="iconfont icon-zhankai-01" :class="tab==3||current_label3?'icon_hover':''"></span>
      </div>
    </div>
    <div class="att_selected" v-if="!show">
      <div class="att" v-if="current_label">转子：{{current_label}}  
        <img class="del_icon" src="@/assets/img/close-icon.png" alt="" @click="delAtt(0)">
      </div>
      <div class="att" v-if="current_label1">RCF：{{current_label1}} 
        <img class="del_icon" src="@/assets/img/close-icon.png" alt="" @click="delAtt(1)">
      </div>
      <div class="att" v-if="current_label2">容量：{{current_label2}} 
        <img class="del_icon" src="@/assets/img/close-icon.png" alt="" @click="delAtt(2)">
      </div>
      <div class="att" v-if="current_label3">材质：{{current_label3}}  
        <img class="del_icon" src="@/assets/img/close-icon.png" alt="" @click="delAtt(3)">
      </div>
    </div>
    <div class="list" :class="show?'no_scroll':''"  ref="activity_scroll" @scroll="activityScroll">
      <div class="win" :class="show1?'height1':'height2'" v-if="show">
        <div class="box">
          <div class="title">{{title}}</div>
          <div class="list2" v-if="show1">
            <div class="items item3" :class="current_cid2==item.id?'hover2':''" v-for="(item,index) in list2" :key="index" @click="changeTab2(item)">{{item.title}}
              <img class="icon" :src="cdnUrl+'eppendorf/gou_icon.png'" v-if="current_cid2==item.id" alt="">
            </div>
          </div>
          <div class="list2 list3" v-if="tab==1">
            <div class="items item2" :class="current_label1==item.title?'hover2':''" v-if="!item.disabled" v-for="(item,index) in rcf_list" :key="index" @click="changeTab(1,item)">{{item.title}}
              <img class="icon" :src="cdnUrl+'eppendorf/gou_icon.png'" v-if="current_label1==item.title" alt="">
            </div>
          </div>
          <div class="list2 list3" v-if="tab==2">
            <div class="items item3" :class="current_label2==item.title?'hover2':''" v-if="!item.disabled" v-for="(item,index) in vol_list" :key="index" @click="changeTab(2,item)">{{item.title}}
              <img class="icon" :src="cdnUrl+'eppendorf/gou_icon.png'" v-if="current_label2==item.title" alt="">
            </div>
          </div>
          <div class="list2 list3" v-if="tab==3">
            <div class="items item3" :class="current_label3==item.title?'hover2':''" v-if="!item.disabled" v-for="(item,index) in material_list" :key="index" @click="changeTab(3,item)">{{item.title}}
              <img class="icon" :src="cdnUrl+'eppendorf/gou_icon.png'" v-if="current_label3==item.title" alt="">
            </div>
          </div>
          <div class="btns">
            <button class="btn1" @click="clear()">清除筛选项</button>
            <button class="btn2" @click="confirm()">确定</button>
          </div>
        </div>
      </div>
      <div class="item" v-for="(item,index) in list" :key="index" @click="hideBox()">
        <div class="name">{{item.title}}</div>
        <div class="content">
          <img class="img" v-if="item.img" :src="cdnUrl +item.img" alt="">
          <div class="img" v-else></div>
          <div class="info">
            <div class="att_item">
              <div class="att_label">最大容量</div>
              <div class="att_value">{{item.max_vol}}mL</div>
            </div>
            <div class="att_item">
              <div class="att_label">最大RCF</div>
              <div class="att_value">{{item.max_rcf}}×g</div>
            </div>
            <div class="att_item">
              <div class="att_label">耗材材质</div>
              <div class="att_value">{{item.material}}</div>
            </div>
            <div class="att_item" v-if="item.spec_count">
              <div class="att_label">规格</div>
              <div class="att_value">{{item.spec_count}}个/套</div>
            </div>
            <div class="att_item">
              <div class="att_label">适配器</div>
              <div class="att_value">{{item.is_adapter?'需要':'不需要'}}</div>
            </div>
             <div class="att_item">
              <div class="att_label">盖子</div>
              <div class="att_value">{{item.is_cover?'需要':'不需要'}}</div>
            </div>
            <div class="att_item">
              <div class="att_label">吊篮</div>
              <div class="att_value">{{item.is_basket?'需要':'不需要'}}</div>
            </div>
            <div class="att_item btn_item" v-if="item.form_id">
              <button class="btn" @click.stop="getFormInfo(item)">咨询详情</button>
            </div>
          </div>
        </div>
        <div class="bottom">
          <div class="b_item">
            <div class="label">货号：</div>
            <div class="value">{{item.number}}</div>
          </div>
          <div class="b_item">
            <div class="label">适配转子：</div>
            <div class="value value1">{{item.applicable_rotor||''}}
              <!-- <span v-for="(items,indexs) in item.category" :key="indexs">{{items.title}}<span v-if="indexs!=item.category.length-1">，</span></span>    -->
            </div>
          </div>
          <div class="more" @click.stop="getMore(index)">
            <i class="iconfont icon-youjiantou" :class="item.open?'open':''"></i>
          </div>
        </div>
        <div class="rotor_box" v-if="item.open">{{item.applicable_rotor||''}}
          <!-- <span v-for="(items,indexs) in item.category" :key="indexs">{{items.title}}<span v-if="indexs!=item.category.length-1">，</span></span>  -->
        </div>
      </div>
      <div class="no-data" v-if="list.length==0">暂无匹配产品</div>
    </div>
    
    <!-- 表单 -->
    <customer-form ref="customerForm" v-if="form_show" :id="currnet_form_id" :type="'consumables_selection'" :type_id="currnet_id" @handleSon="handleSon"></customer-form>
  </div>
</template>

<script>
import HorizontalScroll from '@/components/HorizontalScroll.vue';
import { getProCate } from '@/api/centrifuge'
import { getExpendablesList,checkSelection } from '@/api/expendables'
import customerForm from '@/components/form';
import { getForm } from '@/api/polymerize';
import { action } from '@/api/newSpecial'
export default {
  components: {
    HorizontalScroll,
    customerForm
  },
  data() {
    return {
      cdnUrl: this.$config.baseUrl.cdnUrl,
      page:1,
      last_page:1,
      list:[],
      list1:[],
      list2:[],
      current_cid1:'',
      current_cid2:'',
      show:false,
      show1:false,
      show2:false,
      show3:false,
      show4:false,
      title:'',
      max_vol:'',
      min_vol:'',
      max_rcf:'',
      min_rcf:'',
      material:'',
      rcf_list:[],
      vol_list:[],
      material_list:[],
      current_label:'',
      current_label1:'',
      current_label2:'',
      current_label3:'',
      tab:'',
      type:1,  //1 高速 2 超速
      form_id:'',
      applyFormDataList: [], // 表单列表
      applyFormItem: {},
      current_id:'',
      currnet_form_id:'',
      form_show:false,
      constraints:[],
      currentSelection:{
        material: 0, // 用户选了材质ID
        vol: 0,      // 用户选了容量ID
        rcf: 0       // 用户选了转速ID
      }
    }
  },
  created() {
    this.getCategoryList()
    this.getList()
    this.checkSelection()
  },
  methods: {
    checkSelection(){
      checkSelection({}).then((res)=>{
        this.constraints = res.data
      })
    },
    changeLabel(tab){
      if(this.tab==tab){
        this.tab = ''
        this.show = false
        this.show2 = false
        this.show3 = false
        this.show4 = false
        return false
      }
      this.show = true
      this.tab = tab
      switch (tab) {
        case 1:
          this.title = 'RCF'
          this.show2 = true
          this.show3 = false
          this.show4 = false
          break 
        case 2:
          this.title = '额定容量（mL)'
          this.show3 = true
          this.show2 = false
          this.show4 = false
          break 
        case 3:
          this.title = '耗材材质'
          this.show4 = true
          this.show2 = false
          this.show3 = false
          break 
      }
    },
    clearTabs(){
        this.tab = ''
        this.max_rcf = ''
        this.min_rcf = ''
        this.max_vol = ''
        this.min_vol = ''
        this.material = ''
        this.current_label1 = ''
        this.current_label2 = ''
        this.current_label3 = ''
        this.currentSelection = {
          material: 0, // 用户选了材质ID
          vol: 0,      // 用户选了容量ID
          rcf: 0       // 用户选了转速ID
        }
    },
    getAll(){
        this.show = false
        this.show1 = false
        this.current_cid1 = ''
        this.current_cid2 = ''
        this.list2 = []
        this.clearTabs()
        this.initList()
    },
    changeTab1(item){
        this.tab = ''
        this.title = '转子型号'
        if(this.show&&this.current_cid1==item.id){
          this.show = false
          this.show1 = false
          return false
        }
        if(!this.show&&this.current_cid1==item.id){
          this.show = true
          this.show1 = true
          return false
        }
        this.type = item.title.indexOf('高速')!=-1?1:2
        this.clearTabs()
        this.show = true
        this.show1 = true
        this.current_cid1 = item.id
        this.current_cid2 = ''
        this.list2 = item.children
        this.initList()
    },
    changeTab2(item){
        this.current_cid2 = item.id
        this.current_label = item.title
        this.rcf_list = item.rcf
        this.vol_list = item.vol
        this.material_list = item.material
        this.clearTabs()
        this.check()
        // this.getList()
    },
    changeTab(tab,data){
      switch (tab) {
        case 1:
          this.current_label1 = data.title
          this.max_rcf = data.max
          this.min_rcf = data.min
          this.currentSelection.rcf = data.id
          break 
        case 2:
          this.current_label2 = data.title
          this.max_vol = data.max
          this.min_vol = data.min
          this.currentSelection.vol = data.id
          break 
        case 3:
          this.current_label3 = data.title
          this.material = data.title
          this.currentSelection.material = data.id
          break 
      }
      this.check()
    },
    delAtt(type){
      switch (type) {
        case 0:
          this.current_label = ''
          this.current_cid2 = ''
          break 
        case 1:
          this.current_label1 = ''
          this.max_rcf = ''
          this.min_rcf = ''
          this.currentSelection.rcf = 0
          break 
        case 2:
          this.current_label2 = ''
          this.max_vol = ''
          this.min_vol = ''
          this.currentSelection.vol = 0
          break 
        case 3:
          this.current_label3 = ''
          this.material = ''
          this.currentSelection.material = 0
          break 
      }
      this.check()
      this.initList()
    },
    getCategoryList(){
        getProCate({type:12}).then(res => {
            this.list1 = res
        })
    },
    clear(){
      if(this.show1){
        this.current_cid2 = ''
         this.current_label = ''
      }
      if(this.show2){
        this.current_label1 = ''
        this.max_rcf = ''
        this.min_rcf = ''
        this.currentSelection.rcf = 0
      }
      if(this.show3){
        this.current_label2 = ''
        this.max_vol = ''
        this.min_vol = ''
        this.currentSelection.vol = 0
      }
      if(this.show4){
        this.current_label3 = ''
        this.material = ''
        this.currentSelection.material = 0
      }
      this.check()
    },
    confirm(){
      this.show = false
      this.show1 = false
      this.initList()
    },
    activityScroll () {
        var clientHeight = this.$refs.activity_scroll.clientHeight // 该容器的固定高度
        var scrollTop = this.$refs.activity_scroll.scrollTop // 滚动条距顶部的距离
        var scrollHeight = this.$refs.activity_scroll.scrollHeight // 内容的高度
        var inadvance = 25 // 距离底部距离
        this.scrollTop = scrollTop
        if (scrollHeight - scrollTop - inadvance <= clientHeight) {
            if (this.page < this.last_page) {
                this.page++
                this.getList()
            }
        }
    },
    initList(){
      this.page = 1
      this.last_page = 1
      this.list = []
      this.getList()
    },
    getList(){
      var para={
          page:this.page,
          category_id:this.current_cid2||this.current_cid1,
          max_rcf:this.max_rcf,
          min_rcf:this.min_rcf,
          max_vol:this.max_vol,
          min_vol:this.min_vol,
          material:this.material,
      }
      getExpendablesList(para).then(res => {
          this.list.push(...res.data.data)
          this.last_page = res.data.last_page
      })
    },
    check(){
      this.rcf_list.forEach((item,index)=>{
        item['disabled'] = this.checkDisabled('rcf',item['id'])
      })
      this.vol_list.forEach((item,index)=>{
        item['disabled'] = this.checkDisabled('vol',item['id'])
      })
      this.material_list.forEach((item,index)=>{
        item['disabled'] = this.checkDisabled('material',item['id'])
      })
      this.$forceUpdate()
    },
    /**
     * 判断某个按钮是否应该 disabled
     * @param {string} type  检查的目标类型 ('material', 'vol', 'rcf')
     * @param {number} id    检查的目标ID (比如某个按钮的ID是 5)
     */
    checkDisabled(type, id) {
      // 1. 构造一个“假设选择”的对象
      // 意思就是：如果我点了这个按钮，组合会变成什么样？
      let testSelection = { ...this.currentSelection };
      testSelection[type] = id; // 假设选中了这个 ID

      // 2. 在黑名单里查找是否命中“死路”
      // 只要命中任何一条规则，就说明这个选择是无效的
      const isDeadEnd = this.constraints.some(rule => {
          // 规则匹配逻辑：
          // 如果规则里的值为 0，代表“任意”。
          // 如果规则里的值不为 0，必须精确匹配当前的选择。
           if (rule.category_id !== this.current_cid2) {
            return false;
          }
          
          // 检查材质是否匹配死路
          const matMatch = (rule.material === 0) || (rule.material === testSelection.material);
          
          // 检查容量是否匹配死路
          const volMatch = (rule.vol === 0) || (rule.vol === testSelection.vol);
          
          // 检查转速是否匹配死路
          const rcfMatch = (rule.rcf === 0) || (rule.rcf === testSelection.rcf);

          // 如果三者都命中，说明这是一个死局
          return matMatch && volMatch && rcfMatch;
      });
      return isDeadEnd; // 如果是死路，返回 true (Disabled)，否则 false
    },
    hideBox(){
      this.list.forEach((item,index)=>{
          item['open'] = 0
      })
      this.$forceUpdate()
    },
    getMore(idx){
      this.list.forEach((item,index)=>{
        if(index==idx){
          item['open'] = item['open']==1?0:1
        }else{
          item['open'] = 0
        }
      })
      this.$forceUpdate()
    },
    getFormInfo(item) {
      action({model:'consumables_selection',model_id:item.id,action:'view'})
      this.currnet_id = item.id
      this.currnet_form_id = item.form_id
      this.form_show = true
      this.$nextTick(() => {
        this.$refs.customerForm.showApplyForm()
      })
        // getForm({id: form_id}).then(res => {
        //     this.applyFormDataList = res.data.keys
        //     this.addPhoneCode()
        //     this.$refs.customerForm.showApplyForm()
        // })
    },
    addPhoneCode() { // 添加验证码
        this.applyFormDataList.forEach(item => {
            if (item.type === 2) {
                this.applyFormItem[item.field] = []
            } else {
                this.applyFormItem[item.field] = ''
            }
        })
        let moIndex = ''
        this.applyFormDataList.filter((value,index) => {
            if (value.field == 'mobile') {
                moIndex = index
            }
            if(value.field == 'code') {
                moIndex = false
            }
        })
        if (moIndex) {
            let moblie = {
                field: 'code',
                required: 1,
                title: '验证码',
                type: 3,
                value: "",
                placeholder: "请输入验证码"
            }
            this.applyFormDataList.splice(moIndex+1, 0, moblie)
        }
    },
    handleSon() {
        this.form_show = false
    },
  }
}
</script>

<style lang="scss" scoped>
.page{
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #FFFFFF;
    // display: flex;
    // flex-direction: column;
    .list1{
        width: 100%;
        height: rem(62);
        display: flex;
        align-items: center;
        overflow-x: auto;
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none;
        .item1{
            height: rem(40);
            line-height: rem(40);
            display: inline;
            flex-shrink: 0;
            margin-left: rem(16);
            margin-right: rem(20);
            font-size: rem(16);
            color: #999999;
            position: relative;
            .iconfont{
              position: absolute;
              top: rem(1);
              right: rem(-20);
              transform: rotate(180deg);
            }
            .icon_hover{
              transform: rotate(0deg);
              color: #6CC5DB;
            }
        }
        .item1:first-child{
            margin-right: 0;
        }
        .item1:last-child{
            margin-right: rem(40);
        }
        .hover1{
            color: #333333;
            font-weight: bold;
            position: relative;
            display: inline-block;
        }
        .hover1::after {
          content: '';
          position: absolute;
          left: 0;
          right: 0;
          bottom: rem(4);
          height: rem(8); /* 下划线的高度 */
          background: linear-gradient( 90deg, rgba(165,228,239,0) 0%, #6CC5DB 100%);
          border-radius: 0px rem(6) rem(6) 0px;
        }
    }
    .att_list{
      width: rem(343);
      display: flex;
      justify-content: space-between;
      margin-bottom: rem(12);
      .att_item{
        width: rem(106);
        height: rem(32);
        line-height: rem(32);
        background: #F4F4F4;
        border-radius: rem(2);
        color: #6CC5DB;
        text-align: center;
        .iconfont{
          display: inline-block;
          transform: rotate(180deg);
          margin-left: rem(10);
        }
        .icon_hover{
          transform: rotate(0deg);
        }
      }
      .hover3{
        background: #6CC5DB;
        color: #FFFFFF;
      }
    }
    .att_selected{
      width: rem(343);
      display: flex;
      flex-wrap: wrap;
      .att{
        position: relative;
        color: #999999;
        margin-right: rem(30);
        margin-bottom: rem(12);
        .del_icon{
          width: rem(16);
          height: rem(16);
          position: absolute;
          top: rem(-5);
          right: rem(-16);
        }
      }
    }
    .list{
      width: 100%;
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      overflow-y: auto;
      position: relative;
      .win{
        width: 100%;
        height: 100%;
        position: fixed;
        top: rem(62);
        left: 0;
        background: rgba(0, 0, 0, 0.7);
        display: flex;
        flex-direction: column;
        z-index: 2;
        .box{
          width: 100%;
          min-height: rem(100);
          background: #FFFFFF;
          border-radius: 0 0 rem(8) rem(8);
          display: flex;
          flex-direction: column;
          align-items: center;
          .title{
            width: rem(343);
            font-weight: bold;
            font-size: rem(14);
            color: #333333;
            line-height: rem(20);
            margin-top: rem(15);
          }
          .list2{
            width: rem(343);
            height: rem(364);
            overflow-y: auto;
            display: flex;
            flex-wrap: wrap;
            align-content: flex-start;
            margin-top: rem(12);
            .items{
              width: rem(106);
              height: rem(35);
              background: #F4F4F4;
              border-radius: rem(2);
              margin-right: rem(12);
              margin-bottom: rem(12);
              line-height: rem(35);
              text-align: center;
              position: relative;
              .icon{
                width: rem(13);
                height: rem(13);
                position: absolute;
                right: 0;
                bottom: 0;
              }
            }
            .item2{
              width: rem(165);
            }
            .item2:nth-child(2n){
              margin-right: 0;
            }
            .item3:nth-child(3n){
              margin-right: 0;
            }
            .hover2{
              background: #E9FBFF;
              border: 1px solid #6CC5DB;
              box-sizing: border-box;
            }
          }
          .list3{
            height: unset;
          }
          .btns{
            width: rem(343);
            display: flex;
            justify-content: space-between;
            margin-bottom: rem(17);
            .btn1{
              width: rem(165);
              height: rem(40);
              border-radius: rem(2);
              border: rem(1) solid #CCCCCC;
              font-size: rem(14);
              color: #333333;
              background: #FFFFFF;
            }
            .btn2{
              width: rem(165);
              height: rem(40);
              background: #6CC5DB;
              border-radius: rem(2);
              font-weight: bold;
              font-size: rem(14);
              color: #FFFFFF;
              border: unset;
            }
          }
        }
      }
      .height2{
        top: rem(105);
      }
      .item{
        width: rem(343);
        height: rem(169);
        background: #FFFFFF;
        box-shadow: 0px rem(2) rem(8) 0px rgba(28,106,121,0.16);
        padding: rem(12);
        box-sizing: border-box;
        margin-bottom: rem(17);
        position: relative;
        .name{
          width: 100%;
          font-weight: bold;
          font-size: rem(15);
          color: #272727;
          line-height: rem(21);
        }
        .content{
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: rem(7);
          .img{
            width: rem(90);
            // height: rem(90);
          }
          .info{
            flex: 1;
            margin-left: rem(12);
            display: flex;
            flex-wrap: wrap;
            position: relative;
            .att_item{
              width: rem(49);
              height: rem(48);
              margin-right: rem(6);
              display: flex;
              flex-direction: column;
              justify-content: center;
              // zoom: 0.88;
              .att_label{
                font-weight: bold;
                font-size: rem(10);
                color: #333333;
                line-height: rem(16);
              }
              .att_value{
                font-size: rem(10);
                color: #A1A0A5;
                line-height: rem(16);
              }
              .btn{
                width: rem(57);
                height: rem(24);
                background: #6CC5DB;
                border-radius: rem(2);
                font-size: rem(10);
                color: #FFFFFF;
                border: unset;
                margin-top: rem(10);
              }
            }
            .att_item:nth-child(4n){
              margin-right:0
            }
            .btn_item{
              position: absolute;
              right: rem(10);
              bottom: rem(5);
              margin-right: 0;
            }
          }
        }
        .bottom{
          width: 100%;
          display: flex;
          align-items: center;
          margin-top: rem(11);
          .b_item{
            display: flex;
            align-items: center;
            font-size: rem(10);
            line-height: rem(16);
            margin-right: rem(10);
            .label{
              font-weight: bold;
              color: #333333;
            }
            .value{
              width: rem(59);
              color: #A1A0A5;
            }
            .value1{
              width: rem(120);
              height: rem(16);
              white-space:nowrap;
              overflow:hidden;
              text-overflow:ellipsis;
            }
          }
          .more{
            width: rem(15);
            height: rem(14);
            line-height: rem(14);
            text-align: center;
            background: linear-gradient( 90deg, #6CC5DB 0%, #EDFDFE 100%);
            border-radius: rem(2);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            i{
              font-size: rem(11);
              color: #FFFFFF;
            }
            .open{
              display: inline-block;
              transform: rotate(180deg);
            }
          }
        }
        .rotor_box{
          width: 311px;
          font-size: rem(12);
          color: #A1A0A5;
          line-height: rem(22);
          background: #FFFFFF;
          padding: rem(11);
          box-sizing: border-box;
          word-wrap: break-word;
          box-shadow: 0px rem(2) rem(11) rem(-3) rgba(158,158,158,0.5), 0px rem(2) rem(8) 0px rgba(28,106,121,0.16);
          position: absolute;
          left:rem(16);
          top: rem(164);
          z-index: 1;
        }
      }
      .item:first-child{
        margin-top: rem(4);
      }
      .no-data{
        font-size: rem(11);
        height: rem(45);
        line-height: rem(45);
        text-align: center;
      }
    }
    .no_scroll{
      overflow: hidden;
    }
}
</style>